import React from "react";
import GlobalDataTable from "../GlobalDataTable";
import "./globalDirectory.css";

/**
 * Directory data grid: loading state, {@link GlobalDataTable} with headers,
 * empty row when `isEmpty`, otherwise `children` should be `<tr>` nodes.
 */
export default function GlobalDirectoryGridSection({
  loading = false,
  loadingMessage = "Loading…",
  headers = [],
  isEmpty = false,
  emptyMessage = "No records found.",
  tableAriaLabel = "Data table",
  wrapClassName = "ub-table-wrap",
  tableClassName = "ub-table",
  children
}) {
  if (loading) {
    return (
      <div className="gds-grid ub-table-section">
        <p className="ub-loading">{loadingMessage}</p>
      </div>
    );
  }

  const colSpan = Math.max(headers?.length || 0, 1);

  return (
    <div className="gds-grid ub-table-section">
      <GlobalDataTable
        wrapClassName={wrapClassName}
        tableClassName={tableClassName}
        tableAriaLabel={tableAriaLabel}
        headers={headers}
      >
        {isEmpty ? (
          <tr>
            <td
              colSpan={colSpan}
              style={{ textAlign: "center", padding: "2rem", color: "#6b7280" }}
            >
              {emptyMessage}
            </td>
          </tr>
        ) : (
          children
        )}
      </GlobalDataTable>
    </div>
  );
}
